// app/javascript/controllers/clicker_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  trigger(event) {
    const triggerId = event.currentTarget.dataset.triggerid
    const button = document.getElementById(triggerId)

    if (button) {
      button.click()
    } else {
      console.warn(`No element found with ID: ${triggerId}`)
    }
  }
}
